module.exports = __webpack_public_path__ + "img/scan-and-pay.ae26cd75.svg";